import { connect } from 'react-redux';
import NavBarWithRoles from './NavBarWithRoles';
import { getTranslation } from "../../reducers/common/localization";
import { 
    getCurrentRole, 
    getCurrentSubRole, 
    getCurrentGroup, 
    getSubRoles,
    getGroupsForSubRole, 
    changeCurrentSubRole, 
    changeCurrentGroup,
    getLoading
} from '../../reducers/account/role';
import { getOrgBalance } from '../../reducers/organization/organization';

const mapStateToProps = state => {
    return {
        role: getCurrentRole(state),
        currentSubRole: getCurrentSubRole(state),
        subRoles: getSubRoles(state),
        currentGroup: getCurrentGroup(state),
        groups: getGroupsForSubRole(state),
        balance: getOrgBalance(state),
        loading: getLoading(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onChangeCurrentSubRole: (subRole) => {
            dispatch(changeCurrentSubRole(subRole));
        },
        onChangeCurrentGroup: (group) => {
            dispatch(changeCurrentGroup(group));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBarWithRoles);



// WEBPACK FOOTER //
// ./src/components/navBarWithRoles/NavBarWithRoles.container.js